// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
import { RecipientsEmailFormFormSetInput } from './globalTypes';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { EmailLetterInput } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: EmailLetterMutation
// ====================================================

export interface EmailLetterMutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface EmailLetterMutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: EmailLetterMutation_output_errors_extendedMessages[];
}

export interface EmailLetterMutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: EmailLetterMutation_output_errors[];
  recipients: string[] | null;
}

export interface EmailLetterMutation {
  output: EmailLetterMutation_output;
}

export interface EmailLetterMutationVariables {
  input: EmailLetterInput;
}

export const BlankEmailLetterInput: EmailLetterInput = {
  "recipients": []
};


export const BlankRecipientsEmailFormFormSetInput: RecipientsEmailFormFormSetInput = {
  "email": ""
};

export const EmailLetterMutation = {
  // The following query was taken from EmailLetterMutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation EmailLetterMutation($input: EmailLetterInput!) {
  output: emailLetter(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    recipients
  }
}
${ExtendedFormFieldErrors.graphQL}`,
  name: "EmailLetterMutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: EmailLetterMutationVariables): Promise<EmailLetterMutation> {
    return fetchGraphQL(EmailLetterMutation.graphQL, args);
  },
  blankInput: BlankEmailLetterInput,
};

export const fetchEmailLetterMutation = EmailLetterMutation.fetch;